import {userInfo, setSession, getSession} from '../../utils/config'
let Users = {
  state: {
    user: {}
  },
  mutations: {
    setUser (state, user) {
      setSession(userInfo, user)
      state.user = user
    },
    resetUser (state) {
      setSession(userInfo, {})
      state.user = {}
    }
  },
  getters: {
    getUser (state) {
      if (!state.user.userId) {
        state.user = getSession(userInfo)
      }
      return state.user
    }
  }
}

export default Users



// WEBPACK FOOTER //
// ./src/store/modules/user.js